import { render, staticRenderFns } from "./ServidorDadosPessoais.vue?vue&type=template&id=038f4fe4"
import script from "./ServidorDadosPessoais.vue?vue&type=script&lang=js"
export * from "./ServidorDadosPessoais.vue?vue&type=script&lang=js"
import style0 from "./ServidorDadosPessoais.vue?vue&type=style&index=0&id=038f4fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports